import { Form } from "react-bootstrap";
import { FieldError, RegisterOptions, UseFormRegister } from "react-hook-form";
import stylesInput from "../../../assets/styles/inputs.module.css";
import { useState } from "react";

interface TextInputFieldProps {
    name: string,
    label: string,
    register: UseFormRegister<any>,
    registerOptions?: RegisterOptions,
    error?: FieldError,
    typeFunctionality?: "clear" | "copy" | "default",
    [x: string]: any,
}

const TextInputField = ({name, label, register, registerOptions, error, typeFunctionality = "default", ...props}: TextInputFieldProps) => {
    const [value, setValue] = useState("");
    const { onChange, ...registerRest } = register(name, registerOptions);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
        onChange(e);
    };

    const handleClear = () => {
        setValue("");
        const event = new Event('input', { bubbles: true });
        const input = document.getElementById(name + "-input");
        if (input) {
            Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set?.call(input, '');
            input.dispatchEvent(event);
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <Form.Group className={`mb-3 ${stylesInput.formGroup}`} controlId={name + "-input"}>
            <Form.Label className={stylesInput.label}>{label}</Form.Label>
            <div className={stylesInput.inputWrapper}>
                <Form.Control
                    {...props}
                    {...registerRest}
                    onChange={handleChange}
                    value={value}
                    isInvalid={!!error}
                />
                {value && (
                    <div className={stylesInput.inputActions}>
                        {typeFunctionality === "copy" && (
                            <button
                                type="button"
                                className={stylesInput.inputAction}
                                onClick={handleCopy}
                                title="Копировать"
                            >
                                📋
                            </button>
                        )}

                        {typeFunctionality === "clear" && (
                            <button
                                type="button"
                                className={stylesInput.inputAction}
                                onClick={handleClear}
                                title="Очистить"
                            >
                                ✕
                            </button>
                        )}
                    </div>
                )}
            </div>
            <Form.Control.Feedback type="invalid">
                {error?.message}
            </Form.Control.Feedback>
        </Form.Group>
    );
}

export default TextInputField;